import {
  PIKKO_JACKPOT_OFFER_STATUS_REQUEST,
  PIKKO_JACKPOT_OFFER_STATUS_SUCCESS,
  PIKKO_JACKPOT_OFFER_STATUS_FAIL,
  PIKKO_JACKPOT_REACTIVATE_REQUEST,
  PIKKO_JACKPOT_REACTIVATE_SUCCESS,
  PIKKO_JACKPOT_REACTIVATE_FAIL,
  PIKKO_JACKPOT_RESET,
} from '../constants/pikkoJackpotConstants';

export const pikkoJackpotReducer = (state = {}, action) => {
  switch (action.type) {
    case PIKKO_JACKPOT_OFFER_STATUS_REQUEST:
      return { ...state, offerLoading: true, offerError: null };

    case PIKKO_JACKPOT_OFFER_STATUS_SUCCESS:
      return { ...state, offerLoading: false, offer: action.payload };

    case PIKKO_JACKPOT_OFFER_STATUS_FAIL:
      return { ...state, offerLoading: false, offerError: action.payload };

    case PIKKO_JACKPOT_REACTIVATE_REQUEST:
      return { ...state, reactivateLoading: true, reactivateError: null };

    case PIKKO_JACKPOT_REACTIVATE_SUCCESS:
      return {
        ...state,
        reactivateLoading: false,
        reactivateSuccess: true,
        offer: {
          ...state.offer,
          ...action.payload,
        },
      };

    case PIKKO_JACKPOT_REACTIVATE_FAIL:
      return { ...state, reactivateLoading: false, reactivateError: action.payload };

    case PIKKO_JACKPOT_RESET:
      return {};

    default:
      return state;
  }
};
